import styled from "styled-components";

export const StyledRecoveryFlowAppDownloadQRReadSuccess = styled.div`
    width: 63rem;
`;
